/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_LandInputs */

const cs_enum_land = /** @type {(inputs: Enum_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozemek`)
};

const en_enum_land = /** @type {(inputs: Enum_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land`)
};

/**
* | output |
* | --- |
* | "Land" |
*
* @param {Enum_LandInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_land = /** @type {((inputs?: Enum_LandInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_LandInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_land(inputs)
	return cs_enum_land(inputs)
});